import Folder from '../../src/legacy/Folder.tsx';
export default Folder;
